import { Context } from "@nuxt/types/app";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  // from something [application/pdf image/jpeg] to [application, image]
  function getTypeFromFileType(fileType: string): string {
    const split = fileType.split("/");
    return `.${split[0]}`;
  }

  return {
    getTypeFromFileType,
  };
}
